// 页面内部触发的弹窗会根据 id 插入到 dom 容器内，支持弹窗内容跟随跟随滚动，切勿随意修改删除
export var CnPageScrollDomId = 'cn-ui-page-scroll-container';
export var CnPageScrollDomSelector = "#".concat(CnPageScrollDomId);
